<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.orgName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="退货状态">
                <a-select v-model="queryParam.returnStatus" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">待审核</a-select-option>
                  <a-select-option :value="1">已审核</a-select-option>
                  <a-select-option :value="2">已拒绝</a-select-option>
                  <a-select-option :value="3">已取消</a-select-option>
                  <a-select-option :value="4">已出库</a-select-option>
                  <a-select-option :value="5">已入库</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="退货原因">
                <a-select v-model="queryParam.returnReason" placeholder="请选择" allow-clear>
                  <a-select-option :value="1">质量问题</a-select-option>
                  <a-select-option :value="2">发错货</a-select-option>
                  <a-select-option :value="3">未售退货</a-select-option>
                  <a-select-option :value="4">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['retail:return:create']">
          <a-icon type="plus" />创建退货申请
        </a-button>
      </div>

      <create-form ref="createForm" @ok="getList" />

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      >
        <span slot="returnStatus" slot-scope="text">
          <a-tag :color="getStatusColor(text)">{{ getStatusText(text) }}</a-tag>
        </span>
        <span slot="returnReason" slot-scope="text">{{ getReasonText(text) }}</span>
        <span slot="createTime" slot-scope="text">{{ parseTime(text) }}</span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['retail:return:query']"><a-icon type="eye" />详情</a>
          <a-divider type="vertical" v-if="record.returnStatus === 0" />
          <a @click="handleApprove(record)" v-if="record.returnStatus === 0" v-hasPermi="['retail:return:approve']"><a-icon type="check" />审核</a>
          <a-divider type="vertical" v-if="record.returnStatus === 1" />
          <a @click="handleOutStock(record)" v-if="record.returnStatus === 1" v-hasPermi="['retail:return:out']"><a-icon type="export" />出库</a>
          <a-divider type="vertical" v-if="record.returnStatus === 4" />
          <a @click="handleInStock(record)" v-if="record.returnStatus === 4" v-hasPermi="['retail:return:in']"><a-icon type="import" />入库</a>
          <a-divider type="vertical" v-if="record.returnStatus === 0" />
          <a @click="handleCancel(record)" v-if="record.returnStatus === 0" style="color: red" v-hasPermi="['retail:return:cancel']"><a-icon type="close" />取消</a>
        </span>
      </a-table>
    </a-card>

    <a-modal title="退货单详情" :visible="detailVisible" :footer="null" @cancel="detailVisible = false" width="1000px">
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="退货单号">{{ currentDetail.returnNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ currentDetail.orgName }}</a-descriptions-item>
        <a-descriptions-item label="退货状态">
          <a-tag :color="getStatusColor(currentDetail.returnStatus)">{{ getStatusText(currentDetail.returnStatus) }}</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="退货原因">{{ getReasonText(currentDetail.returnReason) }}</a-descriptions-item>
        <a-descriptions-item label="退货金额">{{ currentDetail.totalAmount }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
        <a-descriptions-item label="出库时间">{{ parseTime(currentDetail.outTime) }}</a-descriptions-item>
        <a-descriptions-item label="入库时间">{{ parseTime(currentDetail.inTime) }}</a-descriptions-item>
      </a-descriptions>
      <a-divider>明细</a-divider>
      <a-table rowKey="id" :columns="itemColumns" :data-source="currentDetail?.items || []" :pagination="false" size="small" />
    </a-modal>

    <a-modal title="审核退货申请" :visible="approveVisible" @ok="handleApproveSubmit" @cancel="approveVisible = false">
      <a-form-model :model="approveForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="approveForm.approved">
            <a-radio :value="true">通过</a-radio>
            <a-radio :value="false">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核意见">
          <a-textarea v-model="approveForm.remark" placeholder="请输入审核意见" :rows="4" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getReturnOrderList, getReturnOrderDetail, approveReturnOrder, outStockReturnOrder, inStockReturnOrder, cancelReturnOrder } from '@/api/retail/return'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'Return',
  components: { CreateForm },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      approveVisible: false,
      currentDetail: null,
      approveForm: { returnOrderId: undefined, approved: true, remark: '' },
      queryParam: { orgName: undefined, returnStatus: undefined, returnReason: undefined, pageNo: 1, pageSize: 10 },
      pagination: { total: 0, current: 1, pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: total => `共 ${total} 条` },
      columns: [
        { title: '退货单号', dataIndex: 'returnNo', width: 180, align: 'center' },
        { title: '门店名称', dataIndex: 'orgName', width: 150, align: 'center' },
        { title: '退货状态', dataIndex: 'returnStatus', width: 100, scopedSlots: { customRender: 'returnStatus' }, align: 'center' },
        { title: '退货原因', dataIndex: 'returnReason', width: 100, scopedSlots: { customRender: 'returnReason' }, align: 'center' },
        { title: '退货金额', dataIndex: 'totalAmount', width: 120, align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', width: 180, scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 250, scopedSlots: { customRender: 'operation' }, align: 'center' }
      ],
      itemColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' },
        { title: '退货单价(元)', dataIndex: 'unitPrice', width: 110, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        { title: '退货数量', dataIndex: 'returnCount', width: 100, align: 'center' },
        { title: '小计金额(元)', dataIndex: 'amount', width: 120, align: 'center', customRender: (text, record) => `¥${((record.unitPrice || 0) * (record.returnCount || 0)).toFixed(2)}` }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    moment,
    parseTime(time) { return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-' },
    getStatusText(status) { const map = { 0: '待审核', 1: '已审核', 2: '已拒绝', 3: '已取消', 4: '已出库', 5: '已入库' }; return map[status] || '-' },
    getStatusColor(status) { const map = { 0: 'orange', 1: 'blue', 2: 'red', 3: 'gray', 4: 'cyan', 5: 'green' }; return map[status] || 'default' },
    getReasonText(reason) { const map = { 1: '质量问题', 2: '发错货', 3: '未售退货', 4: '其他' }; return map[reason] || '-' },
    getList() {
      this.loading = true
      getReturnOrderList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleTableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() { this.queryParam.pageNo = 1; this.getList() },
    resetQuery() { this.queryParam = { orgName: undefined, returnStatus: undefined, returnReason: undefined, pageNo: 1, pageSize: 10 }; this.getList() },
    handleDetail(record) {
      getReturnOrderDetail({ returnOrderId: record.id }).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) { this.approveForm.returnOrderId = record.id; this.approveForm.approved = true; this.approveForm.remark = ''; this.approveVisible = true },
    handleApproveSubmit() {
      approveReturnOrder(this.approveForm).then(() => {
        this.$message.success('审核成功')
        this.approveVisible = false
        this.getList()
      })
    },
    handleOutStock(record) {
      this.$confirm({
        title: '确认出库',
        onOk: () => { outStockReturnOrder({ returnOrderId: record.id }).then(() => { this.$message.success('出库成功'); this.getList() }) }
      })
    },
    handleInStock(record) {
      this.$confirm({
        title: '确认入库',
        onOk: () => { inStockReturnOrder({ returnOrderId: record.id }).then(() => { this.$message.success('入库成功'); this.getList() }) }
      })
    },
    handleCancel(record) {
      this.$confirm({
        title: '确认取消',
        onOk: () => { cancelReturnOrder({ returnOrderId: record.id, remark: '' }).then(() => { this.$message.success('取消成功'); this.getList() }) }
      })
    }
  }
}
</script>
